import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { LoadingService } from './utils/services/loading.service';
import { AuthResponse, AuthService } from './auth/auth.service';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { Observable, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Price Matcher';
  // Expose observables directly
  isConnected$: Observable<boolean>;
  private readonly destroy$ = new Subject<void>();

  isLoading$: Observable<boolean>;
  isLoggedIn: Boolean = false;
  dropdownToggle: boolean = false;
  mobileDropdownToggle: boolean = false;
  activeNavIndex: number | null = null;


  constructor(private loadingService: LoadingService,
    private authService: AuthService,
    private zone: NgZone,
    private router: Router) {

  }

  openLoginDialog() {
    this.authService.openLoginDialog();
  }

  toggleNav(index: number): void {
    this.activeNavIndex = this.activeNavIndex === index ? null : index;
  }

  toggleDropdown() {
    if (this.dropdownToggle) {
      this.dropdownToggle = false;
    } else {
      this.dropdownToggle = true;
    }
  }

  mobileToggleDropdown() {
    if (this.mobileDropdownToggle) {
      this.mobileDropdownToggle = false;
    } else {
      this.mobileDropdownToggle = true;
    }
  }

  logout() {
    this.authService.logout();
  }

  async ngOnInit(): Promise<void> {
    this.authService.listenToInternetConnection();

    this.isConnected$ = this.authService.getOnlineState();
    this.isLoading$ = this.loadingService.isLoading$;

    const authResponse = await this.authService.checkAccountStatus();
    if (authResponse) {
      await this.authService.updateAuthState(authResponse);

    }


    this.authService.getAuthState()
      .pipe(takeUntil(this.destroy$))
      .subscribe(authResponse => {
        this.isLoggedIn = authResponse != null && authResponse.authenticated;
      });

    if (Capacitor.isNativePlatform()) {
      App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
        this.zone.run(() => {
          // Example url: https://beerswift.app/tabs/tab2
          // slug = /tabs/tab2
          const slug = event.url.split(".com").pop();
          if (slug) {
            this.router.navigateByUrl(slug);
          }
          // If no match, do nothing - let regular routing
          // logic take over
        });
      })
    }

  }

  ngOnDestroy(): void {
    this.authService.logout();
  }
}
